import { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Building2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Org filter dropdown for admin users. Renders nothing for non-admin.
 * Usage: <OrgFilter value={orgFilter} onChange={setOrgFilter} />
 */
export function OrgFilter({ value, onChange, className = '' }) {
  const { user } = useAuth();
  const [orgs, setOrgs] = useState([]);

  useEffect(() => {
    if (user?.role !== 'admin') return;
    fetch(`${API}/api/organisations`, { credentials: 'include' })
      .then(r => r.ok ? r.json() : [])
      .then(setOrgs)
      .catch(() => {});
  }, [user]);

  if (user?.role !== 'admin' || orgs.length < 2) return null;

  return (
    <div className={`flex items-center gap-1.5 ${className}`} data-testid="org-filter">
      <Building2 className="w-3.5 h-3.5 text-slate-400" />
      <select
        value={value || ''}
        onChange={e => onChange(e.target.value || null)}
        className="text-xs border rounded-lg px-2 py-1.5 bg-white text-slate-600 min-w-[140px]"
        data-testid="org-filter-select"
      >
        <option value="">All Organisations</option>
        {orgs.map(o => (
          <option key={o.id} value={o.id}>{o.name}</option>
        ))}
      </select>
    </div>
  );
}
